
import React from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from "react-redux";

export default function DropDownForFrequencies(props) {

  const { selectedCategoryOption } = useSelector((state) => state.createOrderSlice)


  const { label, options, onChange, selectedTime } = props;

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          onChange={onChange}
          label={label}
          value={selectedCategoryOption}
        >
          {options.map((item) => {
            return (
              <MenuItem value={item}>{item.option}</MenuItem>
            )

          })}

        </Select>
      </FormControl>
    </Box>
  );


}


